import React from 'react';
import { Link } from 'react-router-dom';
import { useGithub } from '../hooks/useGithub';
import { getAuthUrl } from '../services/github';

const Header: React.FC = () => {
  const { auth, logout } = useGithub();

  // GitHub OAuth client ID (in a real app, this would be in environment variables)
  const clientId = import.meta.env.VITE_GITHUB_CLIENT_ID || 'mock_client_id';
  
  // Generate redirect URI dynamically based on current URL
  const redirectUri = `${window.location.origin}/auth/callback`;
  
  // Generate GitHub OAuth URL
  const authUrl = getAuthUrl(clientId, redirectUri);

  return (
    <header className="bg-dark text-white shadow-md">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <Link to="/" className="text-xl font-bold flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" className="mr-2">
            <path fill="#2ebc4f" d="M12 0C5.373 0 0 5.373 0 12c0 5.302 3.438 9.8 8.205 11.387.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61-.546-1.387-1.333-1.756-1.333-1.756-1.09-.745.083-.73.083-.73 1.205.085 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.468-2.38 1.235-3.22-.123-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.3 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.29-1.552 3.297-1.23 3.297-1.23.653 1.653.24 2.874.118 3.176.77.84 1.235 1.91 1.235 3.22 0 4.61-2.805 5.625-5.475 5.92.43.372.823 1.102.823 2.222 0 1.606-.015 2.896-.015 3.292 0 .32.217.694.825.577C20.565 21.795 24 17.298 24 12c0-6.627-5.373-12-12-12z"/>
          </svg>
          GitHub HTML Tool
        </Link>
        
        <nav>
          <ul className="flex space-x-6">
            <li>
              <Link to="/" className="hover:text-gray-300">
                Home
              </Link>
            </li>
            <li>
              <Link to="/editor" className="hover:text-gray-300">
                Editor
              </Link>
            </li>
            {auth ? (
              <>
                <li>
                  <Link to="/repositories" className="hover:text-gray-300">
                    Repositories
                  </Link>
                </li>
                <li>
                  <div className="flex items-center">
                    <img 
                      src={auth.user.avatar_url} 
                      alt={auth.user.login} 
                      className="w-6 h-6 rounded-full mr-2"
                    />
                    <span>{auth.user.login}</span>
                  </div>
                </li>
                <li>
                  <button 
                    onClick={logout} 
                    className="text-red-400 hover:text-red-300"
                  >
                    Logout
                  </button>
                </li>
              </>
            ) : (
              <li>
                <a 
                  href={authUrl}
                  className="bg-primary px-3 py-1 rounded text-white hover:bg-opacity-90"
                >
                  Login with GitHub
                </a>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header; 